export default __webpack_public_path__ + "static/IBMPlexSans-ThinItalic-Cyrillic-8020555d683395462141bc1555b7c18b.woff";